import { render } from "./insert-areas-popup.vue?vue&type=template&id=26544a42"
import script from "./insert-areas-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./insert-areas-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/insert-areas-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26544a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26544a42', __exports__)) {
    api.reload('26544a42', __exports__)
  }
  
  module.hot.accept("./insert-areas-popup.vue?vue&type=template&id=26544a42", () => {
    api.rerender('26544a42', render)
  })

}


export default __exports__